// Models
import { DossierDto } from 'app/_mapper/dossier.dto';
import { DossierModel } from 'app/_models/Dossier.model';
import { CaseType } from 'app/_models/case-type/add-edit-case-type.model';
import { CaseModel } from 'app/_models/case.model';
import { FellowTraveller } from 'app/_models/fellow-traveller.model';
import { HelpPlanDetailsModel } from 'app/_models/helpPlanDetails.model';
import { InsureeData } from 'app/_models/insuree-data.model';
import { Insuree } from 'app/_models/insuree.model';
import { IntakeModel } from 'app/_models/intake.model';
import { intakeTimeValueModel } from 'app/_models/intakeTimeValue.model';
import { IntakeStepModel } from 'app/_models/intakestep.model';
import { LocationType } from 'app/_models/location-type.model';
import { PolicyControl } from 'app/_models/policycontrol.model';
import { PureCloudInfo } from 'app/_models/pureCloudInfo';
import { SummaryDetailsModel } from "app/_models/summary-details.model";
import { TravelDetailModel } from 'app/_models/travel-detail.model';
import { AdlModel } from 'app/intake/adl/models/adl.model';
import { DbcModel } from 'app/intake/dbc/models/dbc.model';
import { DossierNoteModel } from 'app/intake/note/models/dossier-note.model';
import { RehospitalisationModel } from 'app/intake/rehospitalisation/models/rehospitalisation.model';
import { PieceLayoutModel } from 'app/piece-layout/models/piece-layout.model';

export class SetInsuree {
    static readonly type = "[Intake] SetInsuree";

    constructor(public insuree: Insuree) { }
}

export class SetDraftDossierNumber {
    static readonly type = "[Intake] SetDraftDossierNumber";
    
    constructor(public draftDossierNumber: string) { }
}

export class SetSummary {
    static readonly type = "[Intake] SetSummary";

    constructor(public summary: SummaryDetailsModel) { }
}
export class SetSteps {
    static readonly type = "[Intake] SetSteps ";

    constructor(public steps: IntakeStepModel[]) { }
}
export class SetDossierStatus {
    static readonly type = "[Intake] SetDossierStatus ";

    constructor(public dossierStatus: string) { }
}

export class SetNotes {
    static readonly type = "[Intake] SetNotes ";

    constructor(public notesModel: DossierNoteModel) { }
}

export class SetRehospitalisation {
    static readonly type = "[Intake] SetRehospitalisation ";

    constructor(public rehospitalisation: RehospitalisationModel) { }
}

export class SetAdl {
    static readonly type = "[Intake] SetAdl ";

    constructor(public adl: AdlModel) { }
}

export class SetDbc {
    static readonly type = "[Intake] SetDbc ";

    constructor(public dbc: DbcModel) { }
}

export class ResetState {
    static readonly type = "[Intake] ResetState";

    constructor() { }
}

export class CopyDossier {
    static readonly type = "[Intake] CopyDossier";

    constructor(public intake: IntakeModel, public editMode: boolean) { }
}

export class SetDossier {
    static readonly type = "[Intake] SetDossier";

    constructor(public dossier: DossierDto, public editMode: boolean) { }
}

export class SetLinkedDossier {
    static readonly type = "[Intake] SetLinkedDossier";
    constructor(public linkedDossier: DossierModel[]) { }
}

export class SetParty {
    static readonly type = "[Intake] SetParty";

    constructor(public party: FellowTraveller[],public editMode: boolean) { }
}

export class SetPolicy {
    static readonly type = "[Intake] SetPolicy";

    constructor(public policyControl: PolicyControl, public editMode: boolean) { }
}

export class SetActiveStepsPolicy {
    static readonly type = "[Intake] SetActiveStepsPolicy";

    constructor() { }
}
export class SetCaseDetail {
    static readonly type = "[Intake] setCaseDetail";

    constructor(public caseDetail: CaseModel) { }
}

export class SetTravel {
    static readonly type = "[Intake] SetTravel";

    constructor(public travel: TravelDetailModel) { }
}

export class SetHelpPlan {
    static readonly type = "[Intake] SetHelpPlan";

    constructor(public helpPlans: HelpPlanDetailsModel[]) { }
}

export class SetWorkingOrderLine {
    static readonly type = "[Intake] SetProforma";

    constructor(public workingOrderLine: PieceLayoutModel[],public hpdId: string) { }
}

export class SetStartIntakeTime {
    static readonly type = "[Intake] SetStartIntakeTime";

    constructor(public intakeTimeValue: intakeTimeValueModel) { }
}


export class UpdateSetps {
    static readonly type = '[Intake] UpdateSteps';

    constructor(public caseType: CaseType) { }
}

export class SetPureCloudInfo {
    static readonly type = '[Intake] SetPureCloudInfo';

    constructor(public pureCloudInfo: PureCloudInfo) { }
}


export class ValidateHelpPlan {
    static readonly type = '[Intake] ValidateHelpPlan';
}

export class SaveStore {
    static readonly type = '[Intake] SaveStore';

    constructor() { }
}

export class SetLocations {
    static readonly type = "[Intake] SetLocations";
    constructor(public locations: LocationType[]) { }
}

export class SetCaseType {
    static readonly type = "[Intake] SetCaseType";

    constructor(public caseType: CaseType) { }
}
export class SetDraftDossier {
    static readonly type = "[Intake] SetDraftDossier";

    constructor(public draftDossier) { }
}

export class SetIsUrgent {
    static readonly type = "[Intake] SetIsUrgent";

    constructor(public isUrgent: boolean) { }
}

export class SetInsureeData {
    static readonly type = "[Intake] SetInsureeData";

    constructor(public insureeData: InsureeData) { }
}